import * as React from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

import { Typography } from 'components/DesignSystemV2/Typography';
import { LazyImage } from 'components/LazyImage';
import { withHomePageSection } from 'components/withHomePageSection';
import { colorsV2 } from 'style/colors-v2';
import { fromScreen } from 'utils/media-query/responsive.util';

import { HeadingContainer } from '../HeadingContainer';

export const GCMSRequirements = () => {
  const data = useStaticQuery(graphql`
    {
      gcms {
        jsonContanier(
          where: { name: "CourseLanding2021_Detaill_Requirements" }
        ) {
          content
        }
      }
    }
  `);

  if (!data.gcms.jsonContanier) return null;

  return <Requirements requirements={data.gcms.jsonContanier.content} />;
};

const data = [
  {
    order: 1,
    iconHandle: 'fEXCHWubTLi5w8At656f',
    title: 'Tinh thần học tập, thái độ tốt',
    description:
      'Hệ phương pháp Linearthinking của DOL dù giúp học viên rút ngắn thời gian để tiến bộ nhưng về cơ bản vẫn đòi hỏi học viên phải học nghiêm túc thì mới giỏi lên được. <br /> DOL không hợp với những học viên có tư tưởng không bỏ thời gian và công sức học mà vẫn muốn tiến bộ.'
  },
  {
    order: 2,
    iconHandle: '0NabyWqXSfCFsVF2zpyF',
    title: 'DOL là ngồi nhà thứ 2',
    description:
      'DOL là nơi dạy và học, không phải là nơi mua bán dịch vụ. Giáo viên và tập thể trung tâm DOL có đủ sự tận tâm với học viên, nên DOL mong các bạn học viên có sự tôn trọng với giáo viên và team vận hành trung tâm.'
  }
];

export const Requirements = withHomePageSection(
  props => {
    const { requirements = data } = props;

    return (
      <Wrapper id="course-landing-detail-requirements">
        <HeadingContainer>
          <Typography
            variant="bold/20-28"
            desktopVariant="bold/24-32"
            v3
            className="section-title"
            as="h2"
          >{`Học ở DOL yêu cầu`}</Typography>
        </HeadingContainer>

        <RequirementsContainer>
          {requirements
            .sort((r1, r2) => r1.order - r2.order)
            .map(req => (
              <Requirement key={req.title} requirement={req} />
            ))}
        </RequirementsContainer>
      </Wrapper>
    );
  },
  { selfish: true }
);

Requirements.propTypes = {};

const Wrapper = styled.div`
  ${fromScreen(776)} {
    .section-title {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

const RequirementsContainer = styled.div`
  display: grid;
  gap: 24px;

  ${fromScreen(776)} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Requirement = ({ requirement, ...rest }) => {
  const { iconHandle, description, title } = requirement;
  const ref = React.useRef(null);
  return (
    <RequirementContainer ref={ref} {...rest}>
      <LazyImage
        imgProps={{
          alt: 'requirement'
        }}
        handle={iconHandle}
        ref={ref}
      />
      <Typography style={{ margin: '10px 0 8px 0' }} variant="semi-bold/20-28">
        {title}
      </Typography>
      <Typography
        variant="regular/14"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </RequirementContainer>
  );
};

const RequirementContainer = styled.div`
  padding: 24px;
  border-radius: 8px;
  border: 1px solid ${colorsV2.gray20};
`;
